import {
  getRequest,
  postJsonRequest,
  deleteRequest,
} from '@/utils/api';

import {uri} from '@/api/uri/basisPlatform'



/**
 * @Description: 搜索类目
 */

export function searchClassfy(isOnline) {
  let params = {
    isOnline:isOnline
  }
  return new Promise((resolve, reject) => {
    getRequest(uri.classfy, params).then(resp => {
      resolve(resp.data)
    }).catch(err => {
      reject(err)
    })
  })
}

/**
 * @Description: 平台模块
*/

export function getChunkList() {
  return new Promise((resolve, reject) => {
    getRequest(uri.chunk).then(resp => {
      resolve(resp.data)
    }).catch(err => {
      reject(err)
    })
  })
}

/**
 * @Description: 获取banner  模块
 * @param purpose  1 pc商城 2 移动端
*/

export function getBannerList(purpose) {
  return new Promise((resolve, reject) => {
    getRequest(uri.banner + purpose).then(resp => {
      resolve(resp.data)
    }).catch(err => {
      reject(err)
    })
  })
}

/**
 * @Description:  获取社区活动
*/

export function getActiveList(page, size, addTime) {
  let params = {
    page,
    size
  };
  if (addTime) {
    params.addTime = addTime
  }
  return new Promise((resolve, reject) => {
    getRequest(uri.activity, params).then(resp => {
      resolve(resp.data)
    }).catch(err => {
      reject(err)
    })
  })
}

/**
 * @Description: 根据类目获取相关服务
*/

export function getServiceInfoByPage(params) {
  return new Promise((resolve, reject) => {
    getRequest(uri.getServiceInfoByPage, params).then(resp => {
      resolve(resp.data)
    }).catch(err => {
      reject(err)
    })
  })
}

/**
 * @Description: 平台统计
*/

export function handleShopAccessStatistics(shopBasicId, itemId, itemType,wxminiUuid) {
  let params = {
    shopBasicId,
    itemId,
    itemType,
    wxminiUuid
  }
  return new Promise((resolve, reject) => {
    postJsonRequest(uri.accessStatistics, params).then(resp => {
      if (resp.status === 1) {
        resolve(resp.data);
      } else {
        reject(resp.msg)
      }
    }).catch(err => {
      reject(err)
    })
  })
}




// WEBPACK FOOTER //
// ./src/api/basisPlatform/home.js